module.exports = __webpack_public_path__ + "static/fonts/iconfont.13aba877.ttf";